$(document).ready(function() {
    $('.Gessert_Gruppenreisen').valida();
    $('.kontakt_telefon').mask('0000000000000000000');
    });
    
    //$(document).on('click','.formabsendebutton', function(e){
    $(document).on('submit','.eingabeformular', function(e){
        e.preventDefault();
        var unindexed_array =$(".eingabeformular").serializeArray();
        var indexed_array = {};
    
        $.map(unindexed_array, function(n, i){
            indexed_array[n['name']] = n['value'];
        });
    
        $.ajax({  
                type: "POST",  
                url: "../forms/php/mail_action.php",
                data: "action=send&data="+encodeURIComponent(JSON.stringify(indexed_array)),
                success: function(response)
                {	 				
                    if (response == "OK")
                    {
                        $(".eingabeformular").trigger('reset');
                         $('#alert_placeholder').html('<div class="alert alert-success alert-dismissable"><button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button><span>Ihre Nachricht wurde erfolgreich übermittelt.</span></div>');
                    }
                    else
                    {
                        $('#alert_placeholder').html('<div class="alert alert-danger alert-dismissable"><button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button><span>Die Nachricht konnte nicht versandt werden.</span></div>'); 
                    }
                }    
        });
        
        
    });
    
    $(document).on('submit','.Gessert_Gruppenreisen, .Gessert_Katalogbestellung, .Gessert_Gutscheinanfrage', function(e){
        e.preventDefault();
        var unindexed_array =$(".Gessert_Gruppenreisen, .Gessert_Katalogbestellung, .Gessert_Gutscheinanfrage").serializeArray();
        var indexed_array = {Formular:$(this).attr("class").replace("Gessert_","")};
    
        $.map(unindexed_array, function(n, i){
            indexed_array[n['name']] = n['value'];
        });
    
        $.ajax({  
                type: "POST",  
                url: "../forms/php/mail_action.php",
                data: "action=send&data="+encodeURIComponent(JSON.stringify(indexed_array)),
                success: function(response)
                {	 				
                    if (response == "OK")
                    {
                        $(".Gessert_Gruppenreisen, .Gessert_Katalogbestellung, .Gessert_Gutscheinanfrage").trigger('reset');
                        alert('Ihre E-Mail ist bei uns eingegangen. Wir werden uns in Kürze bei Ihnen melden.');
                    }
                    else
                    {
                        alert('Das Formular konnte leider nicht abgeschickt werden.');					
                    }
                }    
        });
        
        
    });